import { render, staticRenderFns } from "./embed-code-tabs.vue?vue&type=template&id=48ef0825"
import script from "./embed-code-tabs.vue?vue&type=script&lang=js"
export * from "./embed-code-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports